import { Component, Input } from "@angular/core";
import { StateService } from "@geolib/geoappbase-client";
import { TranslatePipe } from "@ngx-translate/core";
import { AppStateMemory } from "./app-state-memory.service";


@Component({
    selector: "geobus-handbook-back-to-app",
    templateUrl: "./handbook-back-to-app.component.html",
    styleUrls: ["./handbook-back-to-app.component.scss"],
    imports: [TranslatePipe],
})
export class HandbookBackToAppComponent {
    @Input() public extensionData: unknown;

    public constructor(
        private readonly appStateMemory: AppStateMemory,
        private readonly stateService: StateService,
    ) {
    }

    public backToApp(): void {
        const lastAppState = this.appStateMemory.lastAppState;

        if (lastAppState) {
            void this.stateService.go(lastAppState.name, lastAppState.params);
        } else {
            void this.stateService.go("app.main");
        }
    }

}
